"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const repeatString = ramda_1.curry(function (str, times) {
    return ramda_1.o(ramda_1.join(''), ramda_1.repeat(str))(times);
});
exports.default = repeatString;
